 
import { ElButton, ElDialog, ElMessage, ElMessageBox } from "element-plus";
import type { ComponentSize, DialogProps } from "element-plus";
import cx from "classnames";
import QuickForm from "../../QuickForm/src/index";
import type { QuickFormPropsType } from "../../QuickForm/src/index";
import DataLoad from "../../DataLoad/src/index.vue";
import type { DataLoadPropsType } from "../../DataLoad/src/index.vue";
import "./style.scss";
import request from "../../utils/request";
import { Component, defineComponent, h, reactive, watch } from "vue";
import type { ComponentPublicInstance, ExtractPropTypes, PropType, SetupContext, StyleValue, VNode } from "vue";
import submitToServerFunc, {
  submitToSeverProps,
} from "../../commonMix/submitToServer";

import { buildProps } from "../../utils/props";
import type { PowerfulBtnType, BtnStateType, RenderNodesType } from "./types";
import cloneDeep from "lodash-es/cloneDeep";
import type { SubmitToSeverOperateType } from "../../commonMix/submitToServer/types";
import type { ButtonProps } from "element-plus";
import isFunction from "lodash-es/isFunction"; 
const PowerfulBtnProps = {
  ...submitToSeverProps,
  ...buildProps({
    asDom: {
      // button以什么元素渲染
      type: [String, Object  as PropType<Component>],
      default: "",
    },
    // button是否有外包装div
    noWrap: {
      type: [Boolean, String],
      default: false,
    },
    block: {
      // button是否是块级元素
      type: Boolean,
      default: false,
    },

    onClick: {
      // button点击方法
      type: Function,
      default: () => {},
    },
    // 按钮类型 fetch form confirmToFetch
    type: {
      type: String,
      default: "diy", 
    },
    // 按钮尺寸
    size: {
      type: String   , 
      default: "",
    },
    // 内部组件设置props 部分 start
    // 设置Form的props
    toSetQuickformProps: {
      type: Object as PropType<Partial<QuickFormPropsType>>, 
      default: () => ({}),
    },
    // 设置button的props
    buttonProps: {
      type: Object  as PropType<Partial<ButtonProps>>,  
      default: () => ({}),
    },
    // 设置dialog默认的props
    dialogDefaultProps: {
      type: Object as PropType<Partial<DialogProps>>,  
      default: () => ({}),
    },
    // 设置dialog的props
    dialogProps: {
      type: Object as PropType<Partial<DialogProps>>,  
      default: () => ({}),
    },
    // 默认就创建dialog出来
    defaultCreatedDialogForm: {
      type: Boolean,
      default: false,
    },
    // 外部value改变是否能直至内部value
    resetToSetValue: {
      type: Boolean,
      default: false,
    },
    // 内部组件设置props 部分 end

    // 类型表单设置部分 start
    modelValue: {
      type: Object,
      default: () => ({}),
    },
   
    // 类型表单设置部分 end

    // 内置数据提交部分  start
    /* 主要部分从其他地方混个 */
    // 当表单弹窗显示之前的控制方法
    beforeGetFormDataDialogShow: {
      type: Function,
      default: (cb:any) => cb(),
    },
    // 内置表单提交部分  end
    // confirmToFetch   提交部分  start
    // 请求的询问文本
    confirmText: {
      type: String,
      default: "确认这样吗？",
    },
    // 请求的标题
    confirmTitle: {
      type: String,
      default: "系统提示",
    },
    // 请求的类型
    confirmType: {
      type: String ,
      default: "warning",
    },

    // confirmToFetch   提交部分  end
    // 当为form类型时，自动获取表单回填数据部分 start
    // 获取表单回填url
    getFormDataConf: {
      type:  Object as PropType<Partial<DataLoadPropsType>>,
      default:()=>({}),
    },
    formFetchToSetValueFilter: {
      type: Function,
      default:(res:any):any => res,
    },
    submitSuccessToCloseDialog: {
      type: Boolean,
      default:true,
    },
    // 请求时候的文本
    loadingText: {
      type: String,
      default: "",
    },
    // 按钮样式
    style: {
      type:[Object as PropType<StyleValue>,String] ,
      default: "",
    },
    // 当为form类型时，自动获取表单回填数据部分 end
  }),
};
export type PowerfulBtnPropsType = ExtractPropTypes<typeof PowerfulBtnProps>;

export default defineComponent({
  name: "PowerfulBtn",
  components: {
    ElButton,
    QuickForm,
    DataLoad,
    ElDialog
  },

  props: PowerfulBtnProps,
  setup(props: PowerfulBtnPropsType, ctx: SetupContext<any>): PowerfulBtnType {
    const btnState: BtnStateType = reactive({
      formValue: cloneDeep(props.modelValue),
      formDataLoading:false,
      getFormDataFetchMergeData:{},
      dialogVisible: false,
    });
    const submitMixResult: SubmitToSeverOperateType = submitToServerFunc(
      props,
      ctx,
      {
        /**
         * 提交调用成功后的回调
         * @param {Object} 返回的值 //
         */
        afterSuccessFunc: (res: any) => {
          console.log("success", res);
          if(props.submitSuccessToCloseDialog){
            btnState.dialogVisible=false;
          }
          btnState.formValue={};
          btnState.formDataLoading=false;
        },
        /**
         * 提交调用失败后的回调
         * @param {Error} 返回的错误信息 //
         */
        afterErrorFunc: (err: any) => {
      
          btnState.formDataLoading=false;
          ElMessage({
            message: err.message ? err.message + "" : err + "",
            type: "error",
          });
        },
      }
    );
    let formDataDialogCallBack:any;
    
    watch(
      () => btnState.formValue,
      (newVal) => {
        ctx.emit("update:modelValue", newVal);
      }
    );
    watch(
      () => props.modelValue,
      (newVal) => {
        if(btnState.formValue!=newVal) btnState.formValue = newVal;
      }
    );
    // 判断不同类型的点击事件
    function onBtnClick(e:MouseEvent):void {
      e.stopPropagation();

      
      if (typeof props.onClick == "function") {
        const res = props.onClick(btnState.formValue);
        if (typeof res == "boolean" && !res) {
          return;
        }
      }
      switch (props.type) {
       
        case "fetch":
          onFetchBtnClick();
          break;
        case "form":
          onFormBtnClick();
          break;
        case "confirmToFetch":
          onConfirmToFetchBtnClick();
          break;
       
        default:
          
          break;
      }
    } 
    function onFetchBtnClick():void {
       submitMixResult.goFetchFunc(props.fetchData);
    } 
    function  onConfirmToFetchBtnClick():void  {
      type MessageType = '' | 'success' | 'warning' | 'info' | 'error';
      ElMessageBox.alert(props.confirmText, props.confirmTitle, {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        showCancelButton:true,
        type: props.confirmType as MessageType, 
      })
        .then(() => {
          submitMixResult.goFetchFunc(props.fetchData);
        })
        .catch(() => {});
    } 
    function onFormBtnClick():void {
      getFormValueData((setValue:any) => {
        // 获取完数据后执行表单显示前置方法，此方法可以让使用组件的人，从外部控制何时显示 Dialog,默认直接展示
        isFunction(props.beforeGetFormDataDialogShow)&& props.beforeGetFormDataDialogShow((v:any) => {
          btnState.formValue = v || setValue;
          btnState.dialogVisible = true;
        }, setValue);
      }, props.fetchData);
    } 
    function  getFormValueData (cb:any, mergeData = {}): void{
      // 获取表单数据回填
      console.log('--- getFormValueData ---')
      const setVal:any =  cloneDeep(btnState.formValue);
      const getFormDataFetchDataParams:any = { ...mergeData };
      if ( props.getFormDataConf && Object.keys(props.getFormDataConf).length) {
        startToLoadingFormData(cb,getFormDataFetchDataParams)
      } else {
        cb(isFunction(props.formFetchToSetValueFilter)&&props.formFetchToSetValueFilter(setVal, getFormDataFetchDataParams));
      }
    } 

    function  startToLoadingFormData (cb:any, mergeData = {}): void{
         btnState.formDataLoading=true;
         btnState.getFormDataFetchMergeData=mergeData;
         formDataDialogCallBack=cb;
    }
    function onFormSubmit(v:any) {
      // 表单提交的方法

      const formData =cloneDeep(v);
      const setFetchData =Object.assign(
        {},
        props.fetchData,
        formData
      );  
      if (!props.url&&!props.fetchApi) {
        // 没有地址则直接传递值
        props.toSetQuickformProps.onSubmit &&
        isFunction(props.toSetQuickformProps.onSubmit) &&
        props.toSetQuickformProps.onSubmit(v, setFetchData, props,btnState );
      } else {
        submitMixResult.goFetchFunc(setFetchData);
      }
    } 

    function onSuccessReset() {
      // 成功以后的重置方法
    
      if (props.type == "form") {
        btnState.dialogVisible = false;
        btnState.formValue = {};
      }
    } 
    /* async goFetchFunc 从混合中提取  */

    function dialogRender():RenderNodesType {
      // 弹框渲染方法
      const {
        type,
        fetchData,
        defaultCreatedDialogForm,
      } = props;
      
      const setForm:VNode =h(QuickForm, {
        ref: "QuickForm",
        ...props.toSetQuickformProps,
        onSubmit: onFormSubmit,
        modelValue: btnState.formValue,
        "onUpdate:modelValue": ($$v:any) => {
          btnState.formValue = $$v;
        },
      
      }); // 设置quick form的内容
      return type == "form" && (defaultCreatedDialogForm || btnState.dialogVisible)
        ? h(
            ElDialog,
            {
            
                title: "提示",
                width: "900px",
                modal: false,
                appendToBody:true,
                ...props.dialogDefaultProps,
                ...props.dialogProps,
                modelValue: btnState.dialogVisible,
                "onUpdate:modelValue": (value:boolean) => {
                  btnState.dialogVisible = value;
                },
             
            },
            setForm
          )
        : null;
    }
    function onLoadFormDataSuccess(data:any):void{
      console.log(data)
      btnState.formDataLoading = false;
      btnState.getFormDataFetchMergeData={}
    
      btnState.formValue=data
      btnState.dialogVisible=true;
    }
    function onLoadFormDataError(e:Error):void{
      console.log(e)
      btnState.formDataLoading = false;
      btnState.getFormDataFetchMergeData={}
      ElMessage({
        type:"error",
        message: e.message,
        showClose:true
      })
    }
    return {
      ...submitMixResult,
      btnState,
      onBtnClick,
      dialogRender,
      onLoadFormDataSuccess,
      onLoadFormDataError
    };
  },
   
  
 
  render(_ctx: ComponentPublicInstance<PowerfulBtnPropsType,PowerfulBtnType> ) {
    const { asDom,  loadingText, block, size, style, buttonProps } = _ctx.$props;

    const setButtonAttrs:ButtonProps = {
     
      size: (size as ComponentSize)|| undefined,
      ...(buttonProps as ButtonProps),
      loading:_ctx.loading,
    };

    const setWrapClass = cx({
      "powerful-btn-wrap": true,
      block: block,
    });
    
     
    const buttonVnode:VNode = asDom  ?  h(
      asDom as string ,
       {
         ...setButtonAttrs,
         style,
         
         onClick: !_ctx.loading ? _ctx.onBtnClick : undefined,
         
       },
       _ctx.loading ? loadingText :{
        default: _ctx.$slots.default
      },
     ): h(
       ElButton ,
        {
          ...setButtonAttrs,
          style,
          
          onClick: !_ctx.loading ? _ctx.onBtnClick : undefined,
          
        },
        _ctx.loading ? loadingText :{
          default: _ctx.$slots.default
        },
      );
   
    if (_ctx.$props.noWrap) {
      /**/

      const bodyLineHeight:number =
        parseFloat(window.getComputedStyle(document.body, null).lineHeight) /
        parseFloat(window.getComputedStyle(document.body, null).fontSize);
      return _ctx.btnState.dialogVisible ? (
        <div
          style={{
            textAlign: "left",
            zIndex: 2000,
            lineHeight: bodyLineHeight,
          }}
          class={`el-button el-button--${
            setButtonAttrs.type ? setButtonAttrs.type : "default"
          } el-button--${setButtonAttrs.size ? setButtonAttrs.size : "mini"} ${
            (setButtonAttrs as any).class || ""
          }`}
        >
          {setButtonAttrs.icon ? <i class={setButtonAttrs.icon} /> : null}
          {_ctx.dialogRender()}
          {_ctx.loading ? loadingText : "-"}{
          _ctx.$slots.default
          }
        </div>
      ) : (
        buttonVnode
      );
    }
    let fetchData={

    }
    if(_ctx.$props.getFormDataConf&&_ctx.$props.getFormDataConf.fetchData){
      fetchData=Object.assign(fetchData, _ctx.$props.getFormDataConf.fetchData )
    }
    return (
      <div class={setWrapClass}>
        {_ctx.dialogRender()}
        {_ctx.btnState.formDataLoading? h(DataLoad,{
          ..._ctx.$props.getFormDataConf,
          fetchData:{
            ...fetchData,
            ..._ctx.btnState.getFormDataFetchMergeData
          },
          onSuccess:_ctx.onLoadFormDataSuccess,
          onError:_ctx.onLoadFormDataError  
        }):null}
        {buttonVnode}
      </div>
    );
  },
});
 
